import { brand } from "./theme/brand";

// Phase colors — used for cut/bulk/maintain sprint visualization
export const phaseColors = {
  cut: brand.accent.primary,        // electric blue
  bulk: brand.state.warning,        // amber
  maintain: "#8b5cf6",              // purple (kept — not in brand palette)
} as const;

// Status colors — used for positive/warning/negative indicators throughout the app
export const statusColors = {
  positive: brand.state.success,
  positiveSoftBg: "rgba(34,197,94,0.14)",
  positiveSoftBorder: "rgba(34,197,94,0.36)",
  positiveTextSoft: "#bbf7d0",
  warning: brand.state.warning,
  warningSoftBg: "rgba(245,158,11,0.14)",
  warningSoftBorder: "rgba(245,158,11,0.35)",
  warningTextSoft: "#fef3c7",
  negative: brand.state.danger,
  negativeSoftBg: "rgba(239,68,68,0.14)",
  negativeSoftBorder: "rgba(239,68,68,0.36)",
  negativeTextSoft: "#fee2e2",
  info: brand.chart.trend,
} as const;

// Action colors — used for interactive buttons and CTAs
export const actionColors = {
  primaryGradient: `linear-gradient(135deg, ${brand.accent.primary}, rgba(59,130,246,0.82))`,
  primaryText: brand.text.primary,  // white text on blue
  secondaryBg: "rgba(255,255,255,0.03)",
  secondaryBorder: "rgba(255,255,255,0.22)",
  secondaryText: "rgba(255,255,255,0.88)",
  dangerBg: "rgba(239,68,68,0.12)",
  dangerBorder: "rgba(239,68,68,0.32)",
  dangerText: "#fca5a5",
} as const;
